import { createFileRoute, Outlet } from '@tanstack/react-router';
import { GoogleRankingLayout } from '@/features/marketing/google-ranking/google-ranking-layout';

/** Marketing › Google Ranking: title + tabs (Overview · Profile fixes · Posts & photos); tabs are child routes. */
export const Route = createFileRoute('/_auth/$orgId/marketing/google-ranking')({
  component: GoogleRankingRoute,
});

function GoogleRankingRoute() {
  const { orgId } = Route.useParams();
  return (
    <GoogleRankingLayout routeOrgId={orgId}>
      <Outlet />
    </GoogleRankingLayout>
  );
}
